import { render, staticRenderFns } from "./DarvasBoxDrawing.vue?vue&type=template&id=4175afd8"
import script from "./DarvasBoxDrawing.vue?vue&type=script&lang=js"
export * from "./DarvasBoxDrawing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports